import { useMemo } from "react";

import { MapFilterEntityType } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import MapFilterModel, {
  ModifiedMapFilterModel,
} from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import doesContainFilterModel from "@app/util/filters/doesContainFilterModel";

// This function ensures that currentFilter contains expectedFilter as a subset.
// If strictMatch is true, then both filters models must be equal to return true
const useStatus = (
  expectedFilterModel: ModifiedMapFilterModel,
  currentFilterModel: MapFilterModel,
  // TODO: actually it's better to have implicitFilterFields per entityType
  implicitFilterFields?: IField[],
  strictMatch?: boolean
): boolean =>
  useMemo(() => {
    const expectedEntities = (Object.keys(expectedFilterModel) as MapFilterEntityType[]).filter(
      (key) => !!expectedFilterModel[key] && Object.keys(expectedFilterModel[key]!).length
    );
    const currentEntities = new Set(
      (Object.keys(currentFilterModel ?? {}) as MapFilterEntityType[]).filter(
        (key) => !!currentFilterModel[key] && Object.keys(currentFilterModel[key]!).length
      )
    );

    // do not proceed with comparison unless current filter model has more entities included
    // or if they are of equal size (when strictly matching)
    // also, current filter model has to include all the entities from expected filter model
    if (
      expectedEntities.length > currentEntities.size ||
      (expectedEntities.length !== currentEntities.size && strictMatch) ||
      !expectedEntities.every((entityType) => currentEntities.has(entityType))
    ) {
      return false;
    }

    return expectedEntities.every((entityType) =>
      doesContainFilterModel(
        expectedFilterModel[entityType] ?? {},
        currentFilterModel[entityType] ?? {},
        implicitFilterFields,
        strictMatch
      )
    );
  }, [expectedFilterModel, currentFilterModel, implicitFilterFields, strictMatch]);

export default useStatus;
